module.exports = __webpack_public_path__ + "fonts/Typo_Round_Bold_Demo.7dd0f53e.otf";